import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-star",
  "use": "spr-star-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"spr-star\"><defs><path id=\"spr-star_a\" d=\"M128.33 602.27l-4.33-2.32-4.33 2.32.87-4.83-3.54-3.4 4.86-.67 2.14-4.42 2.14 4.42 4.86.67-3.54 3.4zM124 584a12 12 0 1 0 0 24 12 12 0 0 0 0-24c-6.63 0 0 0 0 0z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-star_a\" transform=\"translate(-112 -584)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/star.svg
// module id = 283
// module chunks = 0